'use client'

import { useHydrateAtoms } from 'jotai/utils'

import { qrUriAtom } from '../../generatorState'
import { pdfContentAtom, TPdfContent } from './PdfContentState'
import { PdfScreen } from './PdfScreen'

export const PdfLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TPdfContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[pdfContentAtom, content],
	])

	return <PdfScreen previewMode={false} demoMode={false} />
}
